import { QueryKey } from "react-query";

export const createUseServiceGroupKey = (): QueryKey => ["useServiceGroup"];
